import { useEffect, useState } from 'react';
// contexts
import { useExpandedFooterContext } from 'context/productComparison/expanded-footer';
import { useFooterContext, useProductsContext } from 'context';
// COMPONENTS
import { ExpandIcon } from './ExpandIcon';
import { SubTotalValue } from './SubTotalValue';
// INTERFACES
import { TotalCellProps } from './TotalCell.interface';

const TotalCell = ({ skeleton, userLocaleCountryCode }: TotalCellProps): JSX.Element => {
    const { expandedFooter, setExpandedFooter } = useExpandedFooterContext();
    const { footerValues } = useFooterContext();
    const { products } = useProductsContext();
    const [init, setInit] = useState<boolean>(true);
    const [displayValue, setDisplayValue] = useState<string | number>('0');
    const values = products?.reduce((total, { generics, amountSelected }) => {
        const genericsTotal = generics?.reduce((sum, { amountSelected }) => sum + (amountSelected || 0), 0) || 0;
        return total + (amountSelected || 0) + genericsTotal;
    }, 0);

    const updateDisplayValue = () => {
        if (init && footerValues?.total) {
            setDisplayValue(footerValues?.total);
            setTimeout(() => {
                setInit(false);
            }, 1500);
        } else {
            setDisplayValue(values);
        }
    };

    useEffect(() => {
        updateDisplayValue();
    }, [values]);

    return (
        <div style={{ display: 'grid', gridColumn: '1 / 2' }}>
            <ExpandIcon skeleton={skeleton} setExpandedFooter={setExpandedFooter} expandedFooter={expandedFooter} />
            <SubTotalValue skeleton={skeleton} subtotal={displayValue} userLocaleCountryCode={userLocaleCountryCode} />
        </div>
    );
};

export default TotalCell;
